module.exports = __webpack_public_path__ + "img/ritz-1.bae68605.jpeg";